import unescapedText from 'I18n/utils/unescapedText';
// this is a function so unescapedText is not called before it can be used
const buildBaseFilterConfig = () => ({
  ProductType: {
    dataType: 'STRING',
    field: 'productType',
    placeholder: unescapedText('marketplaceStorefront.filters.universal.productType.placeholder'),
    options: [{
      text: unescapedText('marketplaceStorefront.filters.universal.productType.APP'),
      value: 'APP'
    }, {
      text: unescapedText('marketplaceStorefront.filters.universal.productType.AGENT'),
      value: 'AGENT'
    }]
  },
  PortalInstallable: {
    dataType: 'BOOLEAN',
    field: 'portalInstallable',
    allowedAppContext: 'app',
    placeholder: unescapedText('marketplaceStorefront.filters.universal.compatiblePlan.placeholder'),
    options: [{
      text: unescapedText('marketplaceStorefront.filters.universal.compatiblePlan.anyPlan'),
      value: 'anyPlan'
    }, {
      text: unescapedText('marketplaceStorefront.filters.universal.compatiblePlan.myPlanOnly'),
      value: 'myPlanOnly'
    }]
  },
  PricingPlan: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'pricingPlan',
    label: unescapedText('marketplaceStorefront.filters.app.pricingPlan.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.pricingPlan.placeholder')
  },
  HubspotFeatures: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'hubspotFeatures',
    label: unescapedText('marketplaceStorefront.filters.app.hubspotFeatures.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.hubspotFeatures.placeholder')
  },
  Certified: {
    productType: 'APP',
    dataType: 'BOOLEAN',
    field: 'certified',
    label: unescapedText('marketplaceStorefront.filters.app.certified.label'),
    options: [{
      text: unescapedText('marketplaceStorefront.filters.app.certified.label'),
      value: 'true'
    }]
  },
  SyncDirection: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'syncDirection',
    label: unescapedText('marketplaceStorefront.filters.app.syncDirection.label')
  },
  AppLanguages: {
    productType: 'APP',
    dataType: 'STRING',
    isLanguage: true,
    field: 'appLanguages',
    label: unescapedText('marketplaceStorefront.filters.app.appLanguages.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.appLanguages.placeholder')
  },
  SupportLanguages: {
    productType: 'APP',
    dataType: 'STRING',
    isLanguage: true,
    field: 'supportLanguages',
    label: unescapedText('marketplaceStorefront.filters.app.supportLanguages.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.supportLanguages.placeholder')
  }
});
let baseFilterConfig;
export function getBaseFilterConfig() {
  if (!baseFilterConfig) baseFilterConfig = buildBaseFilterConfig();
  return baseFilterConfig;
}